module.exports = __webpack_public_path__ + "static/img/banEn.ea221da.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/banEn.jpg
// module id = nIiD
// module chunks = 1